import React, { useEffect, useState } from 'react'
import { classBorderLabelDark, classInput, classInputDark, classLabel, classLabelDark } from '../../Utils/Types'
import { FaArrowDown, FaSearch, FaTrash } from 'react-icons/fa'
import { IoAddCircleOutline } from 'react-icons/io5'
import { ToolTips } from '../ToolTips/tooltips'


export type DataSearch = {
    id: any,
    description: string,
    //ativo?: any,
    //urlImage?  : string,
    //saldo?     : number,
}

export type ModoPesquisa = | "key_press" | "key_enter"

type Props = {
    dataList: DataSearch[],                             // Armazena os dados recuperados pela api
    idRegistro?: any,                                   // id do elemento selecionado
    label?: string,                                     // responsavel pelo titulo / label do searchBox
    componentId?: string                                // É uma variavel criada para ajudar na condição de navegação do TAB, ela ajuda a diferenciar quando uma tela tiver varios componentes searchBox
    borda?: boolean,                                    // variavel responsavel pela criação da borda vermelha no componente
    visibleTAB?: boolean                                // É uma variavel criada para ajudar na condição de navegação do TAB
    visibleAddItem?: boolean
    disabled?: boolean,                                 // responsavel por controlar se o componente esta habilitado ou não
    limite?: boolean,                                   // variavel responsavel por mostrar codigo / id dos elementos da tabela no componente
    modoPesquisa?: ModoPesquisa                         // variavel responsavel pelo controle de pesquisa do componente
    loading?: boolean

    setDataClick: (data: any) => void,                  // função para selecionar o elemento da tabela
    clearDataClick: () => void,                         // função para limpar o campo do componente e voltar ao original
    filterDataClick: (description: string) => void,     // função pra filtrar os elementos atraves de uma pesquisa
    deleteDataClick?: (id: number) => void,             // função para deletar um elemento da tabela
    additem?: () => void,                               // função para adicionar um item dentro da tabela
    //responsivo?: boolean,                               // variavel responsavel pela visibilidade do componente
    clicado?: () => void,                               // É a função responsavel por tornar a lista do componente visivel, ela foi criado para auxiliar no comando de TAB

}

export const SearchBox = React.memo(({ dataList, idRegistro, label, componentId, borda, visibleTAB, visibleAddItem, disabled, limite, modoPesquisa, loading, setDataClick, clearDataClick, filterDataClick, deleteDataClick, additem, clicado}: Props) => {

    const [dataSearch, setDataSearch] = useState("")
    const [visible, setVisible] = useState(false)
    const [description, setDescription] = useState("")

    const [position, setPosition] = useState(-1)
    const [id, setId] = useState("")

    const [linhaSelecionada, setLinhaSelecionada] = useState<number>(-1)
    const [dadosSelecionado, setDadosSelecionado] = useState<DataSearch>()

    //const [isDivDisabled, setDivDisabled] = useState(false)
    //const [urlImage, setUrlImage]       = useState("")

    const limiteList = 27

    // --------------------------------------------------------- USEEFFECT -----------------------------------------------------------------------
    useEffect(() => {

        if (idRegistro) {

            //console.log("idRegistro: ", idRegistro)
            //console.log("dataList: ", dataList)

            const reg = dataList.filter(item => item.id.toString().trim() === idRegistro.toString().trim())

            //console.log("reg: ", dataList.filter(item => item.id))

            if (reg && reg.length > 0) {
                setDescription(reg[0].description)
                setId(reg[0].id.toString())
            }
        } else {
            setDescription("")
            setId("")
        }

    }, [idRegistro, dataList])

    useEffect(() => {
        //Inputfocus() por equanto isso vai ficar desativado até eu achar um jeito de implementar isso 

        /*
        const handleKeyPressESC = (event: any) => {
            if (event.code === KEY_CODE_ESCAPE) {
                setVisible(false)
                //setDataSearch("")
                filterDataClick("")
            }
        }

        document.addEventListener('keydown', handleKeyPressESC)

        return () => {
            document.removeEventListener('keydown', handleKeyPressESC)

        }
        */

        if (!visible) {
            setLinhaSelecionada(-1)
            setDadosSelecionado({ id: 0, description: '' })
            filterDataClick("")
            setDataSearch("")
        }

    }, [visible])

    useEffect(() => {

        if (disabled) {
            setVisible(false)
        }

    }, [disabled])

    // --------------------------------------------------------- CONDIÇÕES DE INICIO -----------------------------------------------------------------------
    if (disabled === undefined) {
        disabled = false
    }

    /*
    if (responsivo === undefined) {
        responsivo = true
    }
    */

    if (borda === undefined) {
        borda = false
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById(`inputPesq-${componentId}`)
        inputElement?.focus()
    }

    // --------------------------------------------------------- FUNÇÕES DO COMPONENTE -----------------------------------------------------------------------
    const handleDataSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch(e.target.value)
        filterDataClick(e.target.value)

        if (modoPesquisa && modoPesquisa === "key_press") {

        }
    }

    const handleSetVisible = () => {

        if (disabled) {
            return
        }

        if (clicado) {
            clicado()
        }

        setVisible(!visible)
        filterDataClick("")
        setDataSearch("")
    }

    const handleSetDataClick = (v: DataSearch) => {
        setDataClick(v)
        setDescription(v.description)
        if (v.id) {
            setId(v.id.toString())
        } else {
            setId("")
        }

        setVisible(false)
        filterDataClick("")
        setDataSearch("")
    }

    const handleClearDataClick = () => {
        setVisible(false)
        clearDataClick()
        setDataSearch("")
        setDescription("")
    }

    const handleDeleteDataClick = async (id: number, pos: number) => {

        setPosition(pos)
        //setDivDisabled(true)

        if (deleteDataClick) {

            deleteDataClick(id)
            //setPosition(-1)         // tem q alterar isso aqui
            //setDivDisabled(false)
        }
    }

    /*
    const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.code === KEY_CODE_ESCAPE) {
            setVisible(false)
            setDataSearch("")
            filterDataClick("")
        }
    }
    */

    // --------------------------------------------------------- FUNÇÕES DO TAB -----------------------------------------------------------------------
    const handleOnKeyPress = (e: React.KeyboardEvent) => {

        /* ESSA FUNCIONALIDADE ATRAPALHA EM OUTRA TELAS, POR ENQUANTO ELA FICA ASSIM
        if (modoPesquisa && modoPesquisa === "key_enter") {
            if (e.code === "Enter" || e.code === "NumpadEnter") {
                console.log('keyCode ', e.code.trim().toUpperCase())
                filterDataClick(dataSearch)
            }
        }
        */

    }

    const handleKeyDown = (event: any) => {

        if (visible && !visibleAddItem) {

            const { key } = event

            if (key === 'ArrowUp' || key === 'ArrowDown') {
                event.preventDefault()

                let nextIndex
                if (key === 'ArrowUp') {
                    nextIndex = linhaSelecionada !== -1 ? linhaSelecionada - 1 : dataList.length - 1
                } else {
                    nextIndex = linhaSelecionada < dataList.length ? linhaSelecionada + 1 : 0
                }

                const selectedItem = dataList[nextIndex]

                if (selectedItem != undefined) {
                    setDadosSelecionado(selectedItem)
                    setLinhaSelecionada(Math.max(0, Math.min(nextIndex, dataList.length + 1)))

                    const element = document.getElementById(`item-${componentId}-${nextIndex}`)
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        })
                    }

                } else {
                    setLinhaSelecionada(-1)
                    setDadosSelecionado({ id: 0, description: ''})
                    setId('0')
                }

            }
        }
    }

    const handleKeyPressEnter = async (e: any) => {

        if ((e.code === "Enter" || e.code === "NumpadEnter") && visible && !visibleAddItem) {

            e.preventDefault()

            setVisible(false)
            filterDataClick("")
            setDataSearch("")
            setDataClick(dadosSelecionado)
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleKeyPressEnter)
        document.addEventListener('keydown', handleKeyDown)

        return () => {

            document.removeEventListener('keydown', handleKeyPressEnter)
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [visible, visibleAddItem, linhaSelecionada, dataList, dadosSelecionado])

    useEffect(() => {

        setVisible(visibleTAB || false)

    }, [visibleTAB])

    //const CondFocus = (idRegistro || 0) <= 0 && visible && borda ? `border-red-900 text-red-900 dark:border-red-900` : visible ? `border-blue-900 text-blue-900 dark:border-slate-400 ` : ''
    const CondFocus = (idRegistro === '' || idRegistro === 0) && visible && borda ? 'border-red-900 text-red-900 dark:border-red-900' : visible ? `border-blue-900 text-blue-900 dark:border-slate-400 ` : ''

    /*
    <button type='button' tabIndex={-1} className={`${disabled === true ? `cursor-not-allowed` : ``} whitespace-nowrap overflow-hidden w-full text-start `} >
        <strong className={`w-[95%] dark:text-slate-200 font-mono font-light text-sm pr-2 ${id === "" ? `text-blue-500 dark:text-cyan-300` : `text-slate-900`}`}></strong>
    </button>
    */

    return (

        <div className={``}>

            <div className={`${disabled === true ? 'opacity-70' : ''} `}>

                <div className={` ${classInput} ${classInputDark} ${CondFocus} ${disabled === true ? `cursor-not-allowed` : ``} flex items-center justify-between whitespace-nowrap font-mono font-light text-sm ${id === "" ? `text-blue-500 dark:text-cyan-300` : `text-slate-900`}`} onClick={handleSetVisible}>

                    <span className={`w-[95%] pr-2 overflow-hidden`}>{limite === true ? id === "" ? '(selecione)' : id + " - " + description : description || '(selecione)'}</span>

                    <FaArrowDown className={`text-blue-600 dark:text-sky-400 h-4 w-8 flex justify-center`} />
                </div>

                <div id={`bodySearchBox-${componentId}`} className={`absolute ${visible ? 'visible' : 'hidden'} w-full h-auto min-h-[120px] border bg-white dark:bg-slate-600 border-slate-400 dark:border-slate-800 z-30`}>

                    <div className={`relative flex flex-row mx-2 my-2`}>
                        <FaSearch className={`h-3 ml-1 mt-[10px] absolute text-slate-400`} />

                        <input id={`inputSearchBox-${componentId}`} tabIndex={-1} onKeyDown={handleOnKeyPress} className={`${classInput} ${classInputDark} h-8 pl-5 mr-2 w-[90%] outline-none text-sm rounded-sm`} placeholder='Pesquisar' value={dataSearch} autoComplete='off' onChange={handleDataSearch} />

                        {additem &&
                            <div>
                                <button tabIndex={-1} data-tooltip-content="Adicionar" data-tooltip-id={'btn-add'} className={`w-auto`} onClick={additem}>
                                    <IoAddCircleOutline className={`text-slate-600 dark:text-slate-200`} size="25px" />
                                </button>
                                <ToolTips target={'btn-add'} bgColor='rgb(14, 165, 233)' />
                            </div>
                        }

                    </div>

                    <div className={`w-auto min-h-[120px] bg-white `}>

                        <button tabIndex={-1} onClick={handleClearDataClick} className={`flex justify-start items-center bg-blue-700 hover:bg-blue-800 dark:bg-blue-400 dark:hover:bg-blue-500 text-white h-6 w-full text-xs pl-2`} >
                            ( selecione )
                        </button>
                        <ul className={`text-xs font-mono w-full  dark:bg-slate-600 overflow-auto h-[200px] `} tabIndex={-1}>

                            {dataList.map((v, index) => {

                                if (index + 1 > limiteList) {
                                    return
                                } else {

                                    let description = ""
                                    //let ativo = v.ativo === 'N' ? '(INATIVO)' : ''
                                    description = limite === true ? v.id + " - " + v.description  : v.description 
                                    return (

                                        <li key={index} id={`item-${componentId}-${index}`} tabIndex={-1} className={`h-auto w-full px-2 hover:bg-slate-100 dark:hover:bg-slate-500 ${index === linhaSelecionada ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} transition-all duration-200 cursor-pointer border border-b-slate-200 dark:border-b-slate-700 border-x-0 border-t-0`}>

                                            <div className={`flex items-center w-full h-full `}>

                                                {deleteDataClick &&
                                                    <button tabIndex={-1} disabled={loading} className={`flex justify-center items-center w-6 h-6 mx-1 rounded-sm`} onClick={() => handleDeleteDataClick(v.id, index)}>

                                                        {loading && position === index ?
                                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-red-400 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="ativo">
                                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                            </div>
                                                            :
                                                            <FaTrash className={`w-3 h-3 text-red-400 transition-all duration-300 hover:text-red-500`} />
                                                        }
                                                    </button>
                                                }

                                                {/*
                                                
                                                {v.urlImage?.trim() !== "" &&
                                                    <img className='w-16 h-auto hover:scale-150 transition-all duration-200' src={v.urlImage?.trim()} alt={`Imagem do produto ${description}`}/>
                                                }
    
                                                {v.urlImage?.trim() === "" &&
                                                    <MdOutlineNoPhotography className='w-16 h-16 text-gray-400'/>
                                                }
                                                
                                                */}

                                                <button tabIndex={-1} onClick={() => handleSetDataClick(v)} className={`dark:text-slate-200 w-full min-h-[35px] text-start text-sm `}>
                                                    <table className=''>
                                                        <tbody >
                                                            <tr>
                                                                <td className='px-1 break-all py-2'>{description}</td>
                                                                {/* <td className='w-[20%]'>{v.saldo ? 'Saldo '+v.saldo.toString() : ''}</td> */}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </button>
                                            </div>
                                        </li>
                                    )
                                }
                            })}
                        </ul>
                    </div>

                </div>

            </div>

            <label htmlFor="desc_variacao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${CondFocus}`}>{label}</label>

        </div>

    )
})